// extracted by css-extract-rspack-plugin
export default {"headerBanner":"header-fragment__HeaderBanner_headerBanner__zflVl"};